import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { api } from "./api";

// Web/PWA push via Firebase Cloud Messaging. Registers the browser's push token
// with the same /api/push/register endpoint the native apps use, so the server
// fans out visitor (and other) notifications to the browser too — with sound and
// vibration, even when the tab is in the background or closed.
const firebaseConfig = {
  apiKey: "AIzaSyAPIG4Rp-y4wF5FYXRr5CffZTpV6JiCNtI",
  authDomain: "society-plus-a7df2.firebaseapp.com",
  projectId: "society-plus-a7df2",
  storageBucket: "society-plus-a7df2.firebasestorage.app",
  messagingSenderId: "919319390450",
  appId: "1:919319390450:web:a4e90bc17acd289f5f086b",
};
const VAPID_KEY = "BO8_RMCi1oEUElKltO6M2DZfgb1pLwoHPjNSPMNR2QCl1RPz194O0LhF9yUpCEb5RNM45eITJG5U6S6ErppCEnw";

let started = false;

export async function registerWebPush() {
  try {
    if (started) return;
    if (typeof window === "undefined" || !("serviceWorker" in navigator) || !("Notification" in window)) return;
    if (!(await isSupported().catch(() => false))) return; // e.g. iOS Safari not installed to home screen
    started = true;

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    let perm = Notification.permission;
    if (perm === "default") perm = await Notification.requestPermission();
    if (perm !== "granted") { started = false; return; }

    const swReg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swReg });
    if (token) await api.post("/api/push/register", { token, platform: "web" });

    // Foreground: the SW won't auto-display while the tab is focused, so for the
    // urgent visitor prompt we show + sound it ourselves (the in-app card also opens).
    onMessage(messaging, (payload) => {
      const d = payload.data || {};
      if (d.kind !== "VISITOR_APPROVAL") return;
      const n = payload.notification || {};
      try {
        swReg.showNotification(n.title || d.title || "Visitor at the gate", {
          body: n.body || d.body || "Approve or deny entry.",
          tag: d.visitorId ? `visitor-${d.visitorId}` : "visitor",
          data: d,
          requireInteraction: true,
          vibrate: [300, 200, 300, 200, 300],
          renotify: true,
        });
      } catch { /* notifications optional */ }
    });
  } catch (e) {
    started = false;
    console.warn("[webpush] init failed", e && e.message);
  }
}

export function getWebPushToken() { return started; }
